/**
 * Beacon API Service Layer
 *
 * Single source of truth for all API calls.
 * All endpoints call the real Gamma API via httpUtil.
 */
import { fetchAsync } from '../utils/httpUtil';

export const beaconApi = {
  /**
   * GET /payment/{endToEndId}
   * Returns: { paymentMetaData, transformationDetails, statusMap, transmissions, bankResponses }
   */
  getPayment: async (id: string, apiBase: string): Promise<any> => {
    return fetchAsync(`${apiBase}/payment/${encodeURIComponent(id)}`);
  },

  /**
   * GET /file/{fileId}
   * Returns: { file: FileDetailData }
   */
  getFile: async (fileName: string, apiBase: string): Promise<any> => {
    return fetchAsync(`${apiBase}/file/${encodeURIComponent(fileName)}`);
  },

  /**
   * GET /execution/{executionArn}
   * Returns transmission/execution detail with statusMap, lifecycle, etc.
   */
  getExecution: async (executionArn: string, apiBase: string): Promise<any> => {
    return fetchAsync(`${apiBase}/execution/${encodeURIComponent(executionArn)}`);
  },
};
